/**
 * Route for `payout-record-pull`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PayoutRecordPullPage } from "../features/payout-record-pull/PayoutRecordPullPage";

export const payoutRecordPullRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/payout-record-pull",
	component: PayoutRecordPullPage,
});

export default payoutRecordPullRoute;
